import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { vaultActions } from '@src/store/reducers/vaultReducer';

@Component({
    selector: 'my-profile',
    template: require('./my-profile.component.html'),
    styles: [require('./my-profile.component.scss')]
})
export class MyProfileComponent implements OnInit, OnDestroy {
    public user: any;

    private unsubscribe: any;

    constructor(private store: Store) {
        this.store = store;
        this.unsubscribe = this.store.subscribe(() => {
            const userState = this.store.getState().user;
            if (userState && userState.user) {
                this.user = userState.user;
                this.unsubscribe();
            }
        });
    }

    public async ngOnInit() {
        const response = await this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS });
        this.store.dispatch({ type: userActions.GET_USER_GROUPS });
        this.store.dispatch({ type: userActions.GET_DOMAINS });
        this.store.dispatch({ type: cmsActions.GET_ALL_CMS });
        this.store.dispatch({ type: vaultActions.GET_VAULTS });
        this.store.dispatch({ type: vaultActions.GET_VAULTS_WITH_CREDENTIALS });
        this.store.dispatch({
            type: userActions.GET_USER,
            payload: { userId: response.data.id }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/my-profile/my-profile.component.ts